import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
  FormControl,
} from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';
import { OptionTranslateService } from '../../../../../shared/services/option-translate.service';
import { OptionItem } from '../../../../../shared/models/option-translation.model';
import { ValidationMessageComponent } from '../../../../../shared/components/validation-message/validation-message.component';


import { Subject, combineLatest } from 'rxjs';
import { takeUntil, startWith } from 'rxjs/operators';
import { Utils } from '../../../../../Utils/utils';
import { customValidator } from '../../../../../Utils/validator';
import { SHARED_COMPONENTS } from '../../../../../shared/shared-imports';
import { AuthService } from '../../../../../core/services/auth.service';
import { LookupService } from '../../../../../core/services/lookup.service';
import { LOVResponseModel } from '../../../../../shared/models/lov-response.model';
import { LookupKey } from '../../../../../shared/constants/lookup-keys';
import { PersonInquiryService } from '../../../../../core/services/xml/person-inquiry.service';
import { SharedService } from '../../../../../shared/services/shared.service';
import { UserModel } from '../../../../../shared/models/loginuser.model';
import { DocumentServiceType, FieldValue } from '../../../../../shared/constants/services.enum';
import { FolderResponse } from '../../../../../shared/models/documents-response.model';
import { FileComponent } from '../../../../../shared/components/controls/file/file.component';
import { AttachmentService } from '../../../../../core/services/attachment.service';
import { ApiEndPoints, ApiRoot } from '../../../../../shared/constants/api-endpoints';
import { ApiService } from '../../../../../core/services/api.service';
import { SkeletonLoaderComponent } from "../../../../../shared/components/skeleton-loader/skeleton-loader.component";
import { EncryptionResponse } from '../../../../../shared/models/encryption-response.model';
import { DocumentName } from '../../../../../shared/constants/documents-name.enum';

@Component({
  selector: 'app-add-owner-partner',
  imports: [
    TranslateModule,
    ReactiveFormsModule,
    ValidationMessageComponent,
    ...SHARED_COMPONENTS,
    SkeletonLoaderComponent
  ],
  templateUrl: './add-owner-partner.component.html',
  styleUrl: './add-owner-partner.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddOwnerPartnerComponent implements OnInit, OnDestroy {
  @ViewChildren('fileCmp') fileComponents!: QueryList<FileComponent>;
  private destroy$ = new Subject<void>();

  @Input() isOpen = false;
  @Input() title = '';
  @Input() totalShare = 0;
  @Input() data: any = "";
  @Input() allMembersData: any[] = [];
  @Input() showAction: boolean = false;
  @Input() srFolder!: FolderResponse;
  @Input() countryList: any[]=[];
  


  @Output() isOpenChange = new EventEmitter<boolean>();
  @Output() onBtnClick = new EventEmitter<any>();
  @Output() folderMissing = new EventEmitter<void>();
  fieldValue = FieldValue;
  LookupKey: any = LookupKey;
  documentServiceType = DocumentServiceType;

  form!: FormGroup;
  nationalities: OptionItem[] = [];
  roles: any = [];
  partnerTypes: OptionItem[] = [];
  standardOption: OptionItem[] = [];
  tyeOfAddUser: OptionItem[] = [];

  detailFound: boolean = false;
  disableCompanyOption = false;
  loginUserDetail!: UserModel;
  loadingEmirateInfo: boolean = false;
  detailNotFound: boolean = false;
  showSameNameMsg: boolean = false;
  lang: string = "en";
  private lastNotes: string | null = null;
  // Inline edit flag for basic details table
  inlineEdit: boolean = false;

  // This method is used to initialize the class instance using fb, option translate service, shared service, pi svc, cdr, attachment service, and api
  constructor(
    private fb: FormBuilder,
    private optionTranslateService: OptionTranslateService,
    private sharedService: SharedService,
    private piSvc: PersonInquiryService,
    private cdr: ChangeDetectorRef,
    private attachmentService: AttachmentService,
    private api: ApiService
  ) {
    this.lang = sharedService.getCurrentLang() ?? 'en';
    this.form = this.fb.group({
      roles: [[], [Validators.required]],
      typeOfAddUser: [null, [Validators.required]],
      partnerType: [null],
      isResident: [null],
      /** UAE-resident fields */
      emiratesId: [null, [customValidator('emiratesId'), Validators.maxLength(20)]],
      emiratesDob: this.fb.group({
        day: [{ value: null, disabled: true }, [Validators.required]],
        month: [{ value: null, disabled: true }, [Validators.required]],
        year: [{ value: null, disabled: true }, [Validators.required]],
      }),
      /** Non-resident fields */
      passportNumber: [null, [customValidator('safeText'), Validators.maxLength(30)]],
      passportExpiry: this.fb.group({
        day: [null],
        month: [null],
        year: [null],
      }),
      /** Individual fields */
      nameEn: [null, [customValidator('english'), Validators.maxLength(200)]],
      nameAr: new FormControl(null, {
        validators: [customValidator('arabic'), Validators.maxLength(200)],
        updateOn: 'blur'
      }),
      nationality: [null],
      /** Company fields */
      companyNameEn: [null, [customValidator('english'), Validators.maxLength(200)]],
      companyNameAr: [null, [customValidator('arabic'), Validators.maxLength(200)]],
      /** Owner/Partner only */
      share: [null, [Validators.min(0), Validators.max(100)]],
      mobile: [null, [Validators.required, customValidator('mobile')]], 
      countryCode: ["971", [Validators.required]],
      email: [null, [customValidator('email'), Validators.maxLength(200)]],
      documentTradeLicense: [''],
      documentPassport: [''],
      documentEmiratesId: [],
      accountMembershipId: '',
      endDate: ''
    });



    this.loginUserDetail = this.sharedService.getUserProfile(); //this.authService.getUserClaims();
    //get options value
    const lang = (localStorage.getItem('selectedLang') as 'en' | 'ar') || 'en';

    this.roles = this.optionTranslateService.getOptions('roles', lang);
    this.partnerTypes = this.optionTranslateService.getOptions(
      'partnerTypes',
      lang
    );
    this.standardOption = this.optionTranslateService.getOptions(
      'standardOption',
      lang
    );
    this.tyeOfAddUser = this.optionTranslateService.getOptions(
      'tyeOfAddUser',
      lang
    );
  }

  // This method is used to update value
  updateValue() {
    let residentValue: any = "";
    if (this.lang == 'ar') {
      residentValue = this.data?.isResident == FieldValue.YES_AR || this.data?.isResident == FieldValue.YES ? FieldValue.YES_AR : FieldValue.NO_AR;
    }
    if (this.lang != 'ar') {
      residentValue = this.data?.isResident == FieldValue.YES || this.data?.isResident == FieldValue.YES_AR ? FieldValue.YES : FieldValue.NO;
    }
    this.form.patchValue({
      roles: this.data.roles,
      typeOfAddUser: this.data.typeOfAddUser,
      partnerType: this.data.partnerType,
      isResident: residentValue,
      emiratesId: this.data.emiratesId,
      emiratesDob: {
        day: this.data.emiratesDob?.day,
        month: this.data.emiratesDob?.month,
        year: this.data.emiratesDob?.year
      },
      passportNumber: this.data.passportNumber,
      passportExpiry: {
        day: this.data.passportExpiry?.day,
        month: this.data.passportExpiry?.month,
        year: this.data.passportExpiry?.year
      },
      nameEn: this.data.nameEn,
      nameAr: this.data.nameAr,
      nationality: this.data.nationality,
      companyNameEn: this.data.companyNameEn,
      companyNameAr: this.data.companyNameAr,
      share: Number(this.data.share),
      mobile: this.data.mobile,
      countryCode: this.data.countryCode || "971",
      email: this.data.email,
      accountMembershipId: this.data.accountMembershipId,
      endDate: this.data.endDate
    });
    if (!this.showAction) {
      this.form.disable();
    }
    if (this.data.emiratesId) {
      this.detailFound = true;
    }
  }

  // This method is used to toggle inline edit
  toggleInlineEdit() {
    if (this.inlineEdit) {
      // currently editing → only close if valid
      if (
        this.form.get("nameEn")?.valid &&
        this.form.get("nameAr")?.valid &&
        this.form.get("nationality")?.valid
      ) {
        this.inlineEdit = false; // close edit mode
      } else {
        this.form.markAllAsTouched();
      }
    } else {
      // not editing → open edit mode
      this.inlineEdit = true;
    }

    this.cdr.markForCheck();
  }

  // This method is used to enforce individual when restricted
  private enforceIndividualWhenRestricted(): void {
    const roles: string[] = this.form.get('roles')!.value || [];

    const hasManagerOrSignatory = roles.includes('Shares Owner');
    const isAddMyself = this.form.get('typeOfAddUser')!.value === FieldValue.MYSELF;
    if (hasManagerOrSignatory || isAddMyself || (this.form.get('typeOfAddUser')!.value === 'New profile' && this.form.get('roles')!.value.includes("1"))) {
      // Force partner-type to “Individual” (value '1')
      this.form.get('partnerType')!.setValue('Individual', { emitEvent: false });
    }
  }

  // This method is used to update conditional behaviour
  private updateConditionalBehaviour(): void {
    const roles: string[] = this.form.get('roles')!.value || [];
    const isAddMyself = this.form.get('typeOfAddUser')!.value === FieldValue.MYSELF;
    /* Disable the “Company” option when rules say so */
    const hasManagerOrSignatory = roles.includes('Manager') || roles.includes('Authorised Signatory');

    this.disableCompanyOption = hasManagerOrSignatory || isAddMyself;

    /* ---------- Residency & partner-type specific validators ----------- */
    const resident: boolean = (this.form.get('isResident')!.value === FieldValue.YES || this.form.get('isResident')!.value === FieldValue.YES_AR);
    const nonResident: boolean = (this.form.get('isResident')!.value === FieldValue.NO || this.form.get('isResident')!.value === FieldValue.NO_AR);
    const individual: boolean = this.form.get('partnerType')!.value === 'Individual';
    const company: boolean = this.form.get('partnerType')!.value === 'Company';
    const onlyOwner: boolean = roles.length > 0 && roles.includes('Shares Owner');

    let isEDRequired = resident && individual ? true : false;
    let isPPRequired = nonResident && individual ? true : false;
    this.toggleRequired(isEDRequired, [
      'emiratesId',
      'emiratesDob.day',
      'emiratesDob.month',
      'emiratesDob.year'
    ]);
    this.toggleRequired(isPPRequired, [
      'passportNumber',
      'passportExpiry.day',
      'passportExpiry.month',
      'passportExpiry.year'
    ]);

    this.toggleRequired(individual, ['isResident', 'nameEn', 'nameAr']);

    this.toggleRequired(company, [
      'companyNameEn',
      'companyNameAr'
    ]);

    this.toggleRequired(onlyOwner, ['share']);
    this.toggleRequired((isAddMyself || individual || company), ['countryCode', 'mobile', 'email']);
    this.toggleRequired(!isAddMyself, ['nationality']);

    if (isAddMyself && this.loginUserDetail) {
      this.setLogiUserDetail();
    }
  }

  // This method is used to set logi user detail
  setLogiUserDetail() {
    let emitValue = { emitEvent: false };
    if (this.data && this.loginUserDetail['First Name'] == this.data?.nameEn) {
      if (this.loginUserDetail?.['Emirates Id']) {
        this.form.get("isResident")?.setValue(this.lang == 'ar' ? FieldValue.YES_AR : FieldValue.YES, emitValue);
      } else {
        this.form.get("isResident")?.setValue(this.lang == 'ar' ? FieldValue.NO_AR : FieldValue.NO, emitValue);
      }
    } else {
      this.form.get("nameEn")?.setValue(this.loginUserDetail['Name English'] ? this.loginUserDetail['Name English'] :`${this.loginUserDetail['First Name']}`, emitValue);
      this.form.get("nameAr")?.setValue(this.loginUserDetail['Name Arabic'] ? this.loginUserDetail['Name Arabic'] : this.loginUserDetail['Last Name'], emitValue);
      this.form.get("email")?.setValue(this.loginUserDetail['EMail Addr'], emitValue);
      this.form.get("mobile")?.setValue(Utils.parseMobile(this.loginUserDetail['Phone #'], 'number'), emitValue);
      this.form.get("countryCode")?.setValue(Utils.parseMobile(this.loginUserDetail['Phone #'], 'cc'), emitValue);
      this.form.get("nationality")?.setValue(this.loginUserDetail['DC Nationality'], emitValue);
      if (this.loginUserDetail?.['Emirates Id']) {
        this.form.get("isResident")?.setValue(this.lang == 'ar' ? FieldValue.YES_AR : FieldValue.YES, emitValue);
        this.form.get("emiratesId")?.setValue(this.loginUserDetail?.['Emirates Id'], emitValue);
      } else {
        this.form.get("isResident")?.setValue(this.lang == 'ar' ? FieldValue.NO_AR : FieldValue.NO, emitValue);
      }
    }
  }

  // This method is used to toggle required using condition and controls
  private toggleRequired(condition: boolean, controls: string[]): void {
    Utils.addRemoveValidation(this.form, condition, controls);
  }

  // This method is used to get detail by emirate id
  async getDetailByEmirateId() {
    if (this.form.get('emiratesId')?.invalid) {
      return;
    }
    this.detailNotFound = false;
    this.detailFound = false;
    this.loadingEmirateInfo = false;

    let emirateId: any = this.form.get('emiratesId');
    if (emirateId.value) {
      this.loadingEmirateInfo = true;
      this.getPersonDetail(emirateId.value);
    }
  }

  // This method is used to resolve nationality value from country list
  private getMatchedCountryValue(userNationality: string): string | null {
    const normalizedNationality = (userNationality || '').trim().toLowerCase();
    if (!normalizedNationality || !Array.isArray(this.countryList)) {
      return null;
    }

    const matchedCountry = this.countryList?.find((country: any) =>
      (country?.Name || '').trim().toLowerCase() === normalizedNationality
    );

    return matchedCountry?.Value || null;
  }

  // This method is used to get person detail using emirate id
  getPersonDetail(emirateId: string) {
    const requestPayload = {
      identityNumber: emirateId
    };
    this.api.post(
      ApiRoot.ICA_PERSON_INQUIRY,
      ApiEndPoints.GET_PERSON_INQUIRY,
      requestPayload
    ).subscribe({
      // This method is used to handle the next callback using response
      next: (response: any) => {
        if (response && response.errorCode == null) {
          this.detailFound = true;
          this.loadingEmirateInfo = false;
          const profile = response?.personProfileType;
          if (profile) {
            const birthDate = profile?.birthDate;
            const date = birthDate ? new Date(birthDate) : null;
            const fullDate = date && !isNaN(date.getTime())
              ? {
                day: String(date.getDate()).padStart(2, '0'),
                month: String(date.getMonth() + 1).padStart(2, '0'),
                year: date.getFullYear()
              }
              : { day: '', month: '', year: '' };
            this.detailFound = true;

            const emailAddress = profile?.addresses?.address?.localAddress?.emailAddress ?? '';
            const mobileNo = profile?.addresses?.address?.localAddress?.mobileNo ?? '';
            const userNationality = profile?.nationality?.descriptionEnglish ?? '';
            const nationality = this.getMatchedCountryValue(userNationality);
            const fullNameArabic = profile?.personName?.fullNameArabic ?? '';
            const fullNameEnglish = profile?.personName?.fullNameEnglish ?? '';
            this.form.controls['emiratesDob']?.setValue(fullDate);
            this.form.get('emiratesDob')?.updateValueAndValidity();

            this.form.get('nameEn')?.setValue(fullNameEnglish);
            this.form.get('nameAr')?.setValue(fullNameArabic);
            this.form.get('nationality')?.setValue(nationality);
            this.form.get('mobile')?.setValue(mobileNo);
            this.form.get('email')?.setValue(emailAddress);
          } else {
            this.detailFound = false;
            this.detailNotFound = true;

            this.form.get('nameEn')?.setValue('');
            this.form.get('nameAr')?.setValue('');
            this.form.get('nationality')?.setValue(null);
            this.form.get('mobile')?.setValue('');
            this.form.get('email')?.setValue('');
          }
          this.cdr.detectChanges();
        } else {
          this.detailFound = false;
          this.detailNotFound = true;
          this.loadingEmirateInfo = false;
          this.cdr.detectChanges();
        }
      },
      // This method is used to handle the error callback
      error: () => {
        this.detailFound = false;
        this.detailNotFound = true;
        this.loadingEmirateInfo = false;
        this.cdr.detectChanges();
      }
    })
  }

  // This method is used to get person documents
  get partnerDocuments() {
    const partnerType = this.form.get('partnerType')?.value;
    return this.sharedService.getOwnerPartnerDocuments(this.srFolder, partnerType);

  }

  canUploadPartnerDocuments(): boolean {
    if (!this.showAction) {
      return false;
    }

    const partnerType = this.form.get('partnerType')?.value;
    const companyNameEnControl = this.form.get('companyNameEn');
    const nameEnControl = this.form.get('nameEn');

    if (partnerType === FieldValue.COMPANY) {
      return !!companyNameEnControl?.value?.trim() && (companyNameEnControl?.disabled || companyNameEnControl?.valid === true);
    }

    const isEnglishNameValid = !!nameEnControl?.value?.trim() && (nameEnControl?.disabled || nameEnControl?.valid === true);
    const hasIdentityDocumentNumber = !!this.form.get('emiratesId')?.value?.trim() || !!this.form.get('passportNumber')?.value?.trim();

    return isEnglishNameValid && hasIdentityDocumentNumber;
  }

  // This method is used to handle the on init lifecycle hook
  ngOnInit(): void {
    if (this.data) {
      this.updateValue();
    }

    combineLatest([
      this.form
        .get('roles')!
        .valueChanges.pipe(startWith(this.form.get('roles')!.value)),
      this.form
        .get('typeOfAddUser')!
        .valueChanges.pipe(startWith(this.form.get('typeOfAddUser')!.value)),
      this.form
        .get('partnerType')!
        .valueChanges.pipe(startWith(this.form.get('partnerType')!.value)),
      this.form
        .get('isResident')!
        .valueChanges.pipe(startWith(this.form.get('isResident')!.value)),
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.updateConditionalBehaviour());

    /* enforce “Individual” whenever the relevant switches change */
    this.form
      .get('roles')!
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe(() => this.enforceIndividualWhenRestricted());
    this.form
      .get('typeOfAddUser')!
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe(() => this.enforceIndividualWhenRestricted());


    // initialize last notes and watch for changes that impact notes
    this.lastNotes = (this.getNotesValue() || '').toLowerCase();

    const nameEn$ = this.form.get('nameEn')!.valueChanges.pipe(startWith(this.form.get('nameEn')!.value));
    const companyNameEn$ = this.form.get('companyNameEn')!.valueChanges.pipe(startWith(this.form.get('companyNameEn')!.value));
    const emiratesId$ = this.form.get('emiratesId')!.valueChanges.pipe(startWith(this.form.get('emiratesId')!.value));
    const passportNumber$ = this.form.get('passportNumber')!.valueChanges.pipe(startWith(this.form.get('passportNumber')!.value));

    combineLatest([nameEn$, companyNameEn$, emiratesId$, passportNumber$])
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        const currentNotes = (this.getNotesValue() || '').toLowerCase();
        if (this.lastNotes && currentNotes && this.lastNotes !== currentNotes) {
          this.removeIdentityAndTradeDocsByNotes(this.lastNotes);
        }
        this.lastNotes = currentNotes;
      });
  }

  // This method is used to handle the on destroy lifecycle hook
  ngOnDestroy(): void {
  }

  // Remove uploaded Passport/Emirates ID/Trade License when the identifying notes change
  private removeIdentityAndTradeDocsByNotes(prevNotes: string): void {
    try {
      const folder = this.srFolder;
      if (!folder || !Array.isArray(folder.documents) || !prevNotes) return;

      const toDelete = folder.documents.filter((doc: any) => {
        const noteMatch = (doc?.notes || '').toLowerCase() === prevNotes.toLowerCase();
        const dt = (doc?.documentType || '').toString().toLowerCase();
        const isPassportOrEmirates = dt.includes('passport') || dt.includes('emirates') ||  dt.includes('signature_card');
        const isTradeLicense = dt.includes('license') || dt.includes('licence');
        return noteMatch && (isPassportOrEmirates || isTradeLicense);
      });

      // Optimistically remove from UI and trigger child update
      if (toDelete.length > 0) {
        const remaining = (folder.documents || []).filter((d: any) => !toDelete.some((x: any) => x.documentId === d.documentId));
        this.srFolder = {
          ...folder,
          documents: [...remaining],
        } as FolderResponse;
        this.cdr.markForCheck();
      }
      this.sharedService
        .getEncryption(this.documentServiceType.MEMBERSHIP)
        .subscribe({
          // This method is used to handle the next callback using encryption response
          next: (encryptionResponse: EncryptionResponse) => {
            if (!encryptionResponse) {
              return;
            }
            // Step 2: Decode response and stringify
            const response: any = Utils.decodeAndStringify(encryptionResponse);
            toDelete.forEach((doc: any) => {
              this.attachmentService
                .deleteRequest(ApiRoot.JUPITER_REST, ApiEndPoints.DELETE_DOCUMENT, {
                  documentId: doc.documentId,
                  folderId: folder.folderId,
                  folderParentId: folder.folderParentId,
                  folderParentType: folder.folderParentType,
                  validation: response.validation,
                })
                .subscribe({
                  next: () => {
                  }
                });
            });
          }
        })
    } catch (e) {
      // swallow to avoid blocking UX
    }
  }

  // This method is used to handle file change event using event and field
  onFileChange(event: any, field: string) {
    const file = event.target.files?.[0];
    this.form.patchValue({ [field]: file });
  }

  // Submit owner/manager detail
  showShareMsg: boolean = false;
  invalidFieldMsg: any = "";
  showPassportOrSignatureMsg = false;

  // This method is used to submit owner
  submitOwner() {
    const invalidControls = Utils.getInvalidControls(this.form);
    console.warn('Invalid controls:', invalidControls);
    const controlLabels: Record<string, string> = {
      emiratesId: 'Emirates ID',
      passportNo: 'Passport Number',
      licenceNumber: 'License Number',
      // Add other controls here
    };

    let formData = this.form.getRawValue();
    if (this.form.get('isResident')?.value == FieldValue.YES || this.form.get('isResident')?.value == FieldValue.YES_AR && this.form.get('partnerType')?.value == "Individual") {
      if (formData.emiratesId == "" || (formData.emiratesDob?.day == null || formData.emiratesDob?.day == "")) {
        this.detailNotFound = true;
        return;
      }
    }
    // Show invalid filed error
    if (invalidControls.length > 0) {
      let messages = Utils.getInvalidFieldMessages(invalidControls, controlLabels);
      this.invalidFieldMsg = messages.join('\n');
    }
    if (this.form.invalid || Utils.hasMaxLengthError(this.form)) {
      this.form.markAllAsTouched();
      const invalidControls = Utils.getInvalidControls(this.form);
      return;
    }

    this.showPassportOrSignatureMsg = false;
    //check documents upload or not in final submit
    if (this.checkRequiredDocuments()) {
      return;
    }

    const hasPassportCopy = this.sharedService.hasDocumentUploaded(this.srFolder, this.getNotesValue(), 'passport_or_emirates_id_copy');
    const hasSignatureCard = this.sharedService.hasDocumentUploaded(this.srFolder, this.getNotesValue(), 'signature_card');
    if (formData.partnerType == "Individual" && (!hasPassportCopy && !hasSignatureCard)) {
      this.showPassportOrSignatureMsg = true;
      return;
    }

    const roles = formData.roles?.map((r: string) => r.trim()) || [];
    const isOwner = roles.includes('Shares Owner');
    if (!isOwner) {
      formData.share = 0;
    }
    const newShare = formData.roles?.includes('Shares Owner') ? Number(formData.share) : 0;
    // Check if updating an existing owner
    if (this.data?.ownerId) {
      formData['ownerId'] = this.data.ownerId;
      const existingShare = this.data.share;
      // Calculate new total by subtracting old share and adding the new one
      const adjustedTotal = this.totalShare - existingShare + newShare;

      if (adjustedTotal > 100) {
        this.showShareMsg = true;
        return;
      }
    } else {
      // Adding new owner, just add the share
      let name = formData.partnerType == "Individual" ? formData.nameEn : formData.companyNameEn;
      let isMemberExistWithName = this.allMembersData.find((member: any) => member.nameEn == name || member.companyNameEn == name);
      if (isMemberExistWithName) {
        this.showSameNameMsg = true;
        return
      }
      const newTotal = this.totalShare + newShare;
      if (newTotal > 100) {
        this.showShareMsg = true;
        return;
      }
    }
    formData.emiratesId = formData.emiratesId ? formData.emiratesId.replace(/-/g, '') : "";

    this.onBtnClick.emit(formData);
    this.close();
  }

  // Close Modal
  // This method is used to close
  close() {
    this.isOpen = false;
    this.isOpenChange.emit(false);
  }

  // This method is used to handle nationality change event using selected
  onNationalityChange(selected: any) {
    const value = this.form.get('nationality')?.value;
    const mobileControl = this.form.get('mobile');
    const countryCodeControl = this.form.get('countryCode');
    if (!mobileControl || !countryCodeControl) {
      return;
    }
    if (value == FieldValue.UAE || value == FieldValue.UAE_AR) {
      mobileControl.setValidators([Validators.required, customValidator('mobile', 'UAE')]);
      countryCodeControl.setValue("971");
      countryCodeControl.disable();
    } else {
      mobileControl.setValidators([Validators.required, customValidator('mobile')]);
      countryCodeControl.enable();
    }
    mobileControl.updateValueAndValidity({ emitEvent: false });
    countryCodeControl.updateValueAndValidity({ emitEvent: false });
  }
  // method for updae attachment
  // This method is used to handel file event using document and document field
  handelFileEvent(document: any, documentField: any) {
    let documents = Utils.checkIsArray(document);
    //Utils.setControlValidityBasedOnDocument(this.form, documentField, documents);
    const lowerField = (documentField || '').toString().toLowerCase();
    if (lowerField === 'passport_or_emirates_id_copy' || lowerField === 'signature_card') {
      this.showPassportOrSignatureMsg = !(this.sharedService.hasDocumentUploaded(this.srFolder, this.getNotesValue(), 'passport_or_emirates_id_copy') || this.sharedService.hasDocumentUploaded(this.srFolder, this.getNotesValue(), 'signature_card'));

    }
    this.cdr.detectChanges();
  }

  // This method is used to check required documents
  checkRequiredDocuments(): boolean {
    let hasMissing = false;
    this.partnerDocuments?.forEach((doc: any, index: any) => {
      const cmp = this.fileComponents.toArray()[index];
      if (cmp.checkMissing(doc.mandatory)) {
        console.error(`Missing mandatory document: ${doc.nameEn}`);
        hasMissing = true;
      }
    });
    return hasMissing;
  }

  // This method is used to get notes value
  getNotesValue() {
    let notes = "";
    if (this.form.get('partnerType')?.value == FieldValue.COMPANY && this.form.get('companyNameEn')?.value) {
      notes = this.form.get('companyNameEn')?.value;
    } else {
      if (this.form.get('emiratesId')?.value && this.form.get('isResident')?.value == FieldValue.YES || this.form.get('isResident')?.value == FieldValue.YES_AR) {
        notes = `${this.form.get('emiratesId')?.value}_${this.form.get('nameEn')?.value}`;
      } else {
        notes = `${this.form.get('passportNumber')?.value}_${this.form.get('nameEn')?.value}`;
      }
    }
    return notes;
  }

  downloadTemplateFile() {
    const link = document.createElement('a');
    link.href = DocumentName.SIGNATURE_CARD;
    link.target = '_blank';
    // link.download = 'Signature_Card.pdf';
    // document.body.appendChild(link);
    link.click();
    // document.body.removeChild(link);
  }
}
